import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Techdevelopment(props) {
  return (
    <div className="tekrevol_development p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <div className="example" data-text="ERP Software">
              <h2>Our ERP Development Services</h2>
            </div>
            <p>
              We assist businesses improve their operational strategies and
              efficiently manage company operations by deploying next-generation
              digital technology. Being an industry leader in ERP system
              development, we offer custom ERP development services that focus
              on creating a scalable, responsive, and feature-rich business app.
              Our ERP developers put you in charge of the software by building
              and configuring it to meet your specific company needs. Here are
              the services we offer:
            </p>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <div className="bulet_points">
              <ul>
                <li>ERP implementation consultancy&nbsp;</li>
                <li>ERP Mobile Applications Development</li>
                <li>ERP Customization and Enhancement</li>
                <li>ERP development</li>
                <li>ERP testing and deployment</li>
                <li>Cloud-based ERP migration</li>
              </ul>
              <p>Need other custom ERP software development services?&nbsp;</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Techdevelopment;
